import type { GraphState } from 'components/Graph/GraphState';
import { selectNodeIds } from 'components/Graph/model/selectors/selectNodeIds';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectGraphHasContent: (s: GraphState) => boolean =
  createScopedSelector(() =>
    createSelector(selectNodeIds, (nodes) => nodes.length > 0),
  );
